import { createAction } from 'redux-actions';
import * as substanceFormTypes from './substanceFormTypes';

export const onCramerClasseSelected = createAction(substanceFormTypes.CRAMER_CLASSE_SELECTED, code => ({
    code,
  }));
